<template>
  <div class="card debug-window">
    <div class="card-body">
      <p>Error list:</p>
      <hr/>
      <div class="error-message" v-if="parsedErrors.length">
        <div class="error" v-for="(error, index) in parsedErrors" :key="`error-${index}`">
          <p class="title">Error #{{index+1}}</p>
          <div class="mb-2" v-for="(value, key) in error" :key="key">
            <span>{{key}}: </span>
            <span>{{value}}</span>
          </div>
          <hr/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userGetters from '../../store/modules/users/getterTypes'
import { mapGetters } from 'vuex'

export default {
  name: 'DebugWindow',
  computed: {
    ...mapGetters({
      errors: userGetters.GET_ERRORS
    }),
    parsedErrors () {
      let errorData = []
      if (this.errors.length) {
        this.errors.forEach(el => {
          if (el.response) {
            errorData.push({
              message: el.response.data,
              status: el.response.status,
              headers: el.response.headers,
              config: el.response.config
            })
          } else {
            errorData.push({
              message: el.data.message,
              status: el.status,
              headers: el.headers,
              config: el.config
            })
          }
        })
      }
      return errorData
    }
  }
}
</script>

<style scoped>
.debug-window {
  opacity: 0.55;
  position: absolute;
  bottom: 20px;
  width: 500px;
  right: 20px;
  height: 350px;
  margin: 0;
}
.card-body {
  width: 100%;
  overflow-y: scroll;
}
.error-message {
  color: darkred;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: 450px;
}
p {
  width: 450px;
}
.title {
  font-size: 18px;
}
</style>
